import { useState } from "react";
import { Head } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Upload } from "lucide-react";
import { PlatformConsoleBreadcrumb } from "@/components/platform_console/PlatformConsoleBreadcrumb";

export default function GrantNew() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const token = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");
    if (token) formData.append("authenticity_token", token);
    setError(null);
    setLoading(true);
    try {
      const res = await fetch("/grants", {
        method: "POST",
        credentials: "same-origin",
        body: formData,
      });
      if (res.redirected) {
        window.location.href = res.url;
      } else {
        setError("Upload failed.");
      }
    } catch {
      setError("Upload failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Head title="Upload Grants" />
      <div className="min-h-screen bg-background p-6">
        <div className="max-w-2xl mx-auto">
          <PlatformConsoleBreadcrumb section="grants" current="Upload Grants" className="mb-6" />

          <Card>
            <CardHeader>
              <CardTitle>Upload Grants CSV</CardTitle>
              <p className="text-sm text-muted-foreground">
                Upload a CSV file of federal assistance programs. Processing will
                run in the background.
              </p>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-4">
                {error && (
                  <div className="p-4 bg-destructive/10 text-destructive rounded-md text-sm">
                    {error}
                  </div>
                )}
                <div className="flex gap-2">
                  <Input
                    type="file"
                    name="file"
                    accept=".csv"
                    className="flex-1"
                    disabled={loading}
                  />
                  <Button type="submit" disabled={loading}>
                    {loading ? (
                      <span className="animate-pulse">Uploading…</span>
                    ) : (
                      <>
                        <Upload className="h-4 w-4 mr-2" />
                        Upload
                      </>
                    )}
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
}
